import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import Report from '../../../../common/components/Report';

const IpcEquipmentPoolsPredesResdesAnalysisReport = props => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.IPC_BAG_IS_PREDES_RESDES_ANALYSIS.id,
        label: 'IPC Bag (IS)',
      },
      {
        value: ReportDefinitions.IPC_TRAY_IL_PREDES_RESDES_ANALYSIS.id,
        label: 'IPC Tray (IL)',
      },
      {
        value: ReportDefinitions.IPC_PALLET_BOX_IB_PREDES_RESDES_ANALYSIS.id,
        label: 'IPC Pallet Box (IB)',
      },
      {
        value: ReportDefinitions.RECEPTACLES_PREDES_RESDES_ANALYSIS.id,
        label: 'Receptacles',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.type.c.reports',
      },
    ]}
    {...props}
  />
);
export default IpcEquipmentPoolsPredesResdesAnalysisReport;

IpcEquipmentPoolsPredesResdesAnalysisReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
};
